import {useContext} from "react";
import {RestorationContainer, HeaderCentered} from "./restoration.styles";

import rack1ru from '../../assets/img/1-ru.jpg';
import rack2ru from '../../assets/img/2-ru.jpg';
import rack3ru from '../../assets/img/3-ru.jpg';
import rack4ru from '../../assets/img/4-ru.jpg';
import rack1ro from '../../assets/img/1-ro.jpg';
import rack2ro from '../../assets/img/2-ro.jpg';
import rack3ro from '../../assets/img/3-ro.jpg';
import rack4ro from '../../assets/img/4-ro.jpg';

import {LanguageContext} from "../../contexts/language.context";
import "./styles.scss";

const Restoration = ({props}) => {
    const {romanianLanguage} = useContext(LanguageContext);

    const images = romanianLanguage
        ? [rack1ro, rack2ro, rack3ro, rack4ro]
        : [rack1ru, rack2ru, rack3ru, rack4ru];

    return (
        <RestorationContainer>
            <HeaderCentered>
                <h2>{props[1]}</h2>
            </HeaderCentered>
            <div className="restoration-items">
                {images.map((image, index) => (
                    <div className="restoration_item" key={index}>
                        <img src={image} alt={`Rack ${index + 1}`}/>
                    </div>
                ))}
            </div>
        </RestorationContainer>
    );
};

export default Restoration;
